/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class ContentFactory
 * @hideconstructor
 * @classdesc API class that is used to generate content specs and create them
 */
define([
	'../../../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../ContentFactoryAPI'
], (APIFactory, ContentFactoryAPI) => {
	class ContentFactory {
		constructor() {
			this._providers = [];
		}

		getAPI() {
			return APIFactory.createAPI(this, [ContentFactoryAPI]);
		}

		registerProvider(provider) {
			this._providers.push(provider);
		}

		_searchProviders(type) {
			return this._providers.find(provider => provider.getTypeList().includes(type));
		}

		addModel(content) {
			const provider = this._searchProviders(content.type) || this._searchProviders();
			return provider.addModel(...arguments);
		}

		createContent(options) {
			const provider = this._searchProviders(options.type) || this._searchProviders();
			return provider.createContent(...arguments);
		}
	}
	return ContentFactory;
});
